module.exports = __webpack_public_path__ + "static/entities-2258b38ec76fcd0cc65bccd2a716deec.png";